import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import DaybookService from "../../../../services/OrderingServices/DaybookService";
import SettingService from "../../../../services/OrderingServices/SettingService";
import toast from "react-hot-toast";
import DaySkeletonCard from "../DaySkeletonCard";
import CloseSummaryPrint from "./CloseSummaryPrint";
import NumberWithCommas from "../../../../pages/Pages/Starter/NumberWithCommas";

const DayCloseDashboard = () => {
  const [isDayOpen, setIsDayOpen] = useState(null);
  const [loading, setLoading] = useState(true);
  const [orderData, setOrderData] = useState([]);
  console.log("🚀 ~ DayCloseDashboard ~ orderData:", orderData);
  const [paymentSummaryData, setPaymentSummaryData] = useState([]);
  const [errorResponse, setErrorResponse] = useState();
  const [daySettingData, setDaySettingData] = useState();
  const [showCloseModal, setShowCloseModal] = useState(false);
  console.log("🚀 ~ DayCloseDashboard ~ showCloseModal:", showCloseModal);
  const [responseModal, setResponseModal] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [ongoingOrderAmount, setOngoingOrderAmount] = useState(0);
  const [ongoingOrderCount, setOngoingOrderCount] = useState(0);
  const [totalSalesAmount, setTotalSalesAmount] = useState(0);

  const toggleResponse = () => {
    setResponseModal(!responseModal);
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const results = await Promise.allSettled([
          DaybookService.paymentTypeSummary(),
          DaybookService.orderSummary(),
          SettingService.getDaySetting(),
        ]);

        // Destructure results
        const [paymentResult, orderResult, settingResult] = results;
        console.log("🚀 ~ fetchData ~ orderResult:", orderResult);

        // Handle paymentTypeSummary
        if (paymentResult.status === "fulfilled") {
          const summary = paymentResult.value || {};

          setPaymentSummaryData(summary.paymentSummary || []);
          setOngoingOrderAmount(summary.ongoingOrderAmount || 0);
          setOngoingOrderCount(summary.ongoingOrderCount || 0);
          setTotalSalesAmount(summary.totalSalesAmount || 0); // ⭐ ADD THIS
        } else {
          console.error(
            "Error fetching payment summary:",
            paymentResult.reason
          );
          setErrorResponse(
            paymentResult.reason?.response?.data?.message ||
              "Payment summary failed"
          );
        }

        // Handle orderSummary
        if (orderResult.status === "fulfilled") {
          const value = orderResult.value || {};
          setOrderData(orderResult.value.items || []);
        } else {
          console.error("Error fetching order summary:", orderResult.reason);
        }

        // Handle day settings
        if (settingResult.status === "fulfilled") {
          setDaySettingData(settingResult.value);
          setIsDayOpen(settingResult.value.isActive);
        } else {
          console.error("Error fetching day setting:", settingResult.reason);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleDayToggle = async () => {
    const newStatus = !isDayOpen;
    console.log("🚀 ~ handleDayToggle ~ newStatus:", newStatus);

    // If trying to close the day (newStatus = false) and there are orders, show modal
    if (!newStatus) {
      setShowCloseModal(true);
      return;
    }

    // Proceed with day toggle
    await performDayToggle(newStatus);
  };

  const performDayToggle = async (newStatus) => {
    setIsDayOpen(newStatus);
    setLoading(true);
    try {
      let response;
      if (!newStatus) {
        // closing day
        const response = await DaybookService.closeSummary();
        setResponseData(response);
        setIsDayOpen(false); // explicitly set
        toggleResponse();
        toast.success("Day is closed!!");
      } else {
        // opening day
        const response = await SettingService.setOpenDay();
        setIsDayOpen(true); // explicitly set
        toast.success(response);
      }

      // await Promise.all([
      //   DaybookService.paymentTypeSummary(),
      //   SettingService.getDaySetting(),
      // ]);
    } catch (error) {
      console.error("Error updating day setting:", error);
      toast.error(error?.response?.data);
      setIsDayOpen(!newStatus); // Rollback state
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmClose = async () => {
    setShowCloseModal(false);
    await performDayToggle(false); // Close the day
  };

  const handleCancelClose = () => {
    setShowCloseModal(false);
    // Switch should stay in the current position (open)
  };

  if (loading) {
    return (
      <>
        <DaySkeletonCard />
      </>
    );
  }

  return (
    <Card
      className={`border ${isDayOpen ? "border-success" : "border-danger"}`}
      style={{ minHeight: "335px", borderRadius: "1rem", overflow: "hidden" }}
    >
      <CardHeader className="ps-3 py-3">
        <div className="d-flex justify-content-between align-items-center">
          <h5
            className={`mb-0 fw-bold ${
              isDayOpen ? "text-success" : "text-danger"
            }`}
          >
            Day {isDayOpen ? "Open" : "Close"}
          </h5>
          <div className="form-check form-switch form-switch-lg  " dir="ltr">
            <input
              type="checkbox"
              className={`form-check-input day-switch`}
              id="customSwitchsizelg"
              checked={isDayOpen}
              onChange={handleDayToggle}
              disabled={loading}
              style={{
                backgroundColor: isDayOpen ? "#28a745" : "#dc3545",
                borderColor: isDayOpen ? "#28a745" : "#dc3545",
              }}
            />
          </div>
        </div>
      </CardHeader>
      <CardBody className="px-3 pt-2 pb-1">
        <div className="d-flex justify-content-between mb-0">
          <h6>Order Summary</h6>
          <Link to="/dayclose/order-summary">
            <button className="btn btn-sm btn-soft-secondary rounded-5">
              <i className="ri-eye-line"></i>
            </button>
          </Link>
        </div>
        <h5
          className={`fs-4 fw-bold  ${
            isDayOpen ? "text-success" : "text-danger"
          }`}
        >
          <CountUp
            start={0}
            end={Array.isArray(orderData) ? orderData.length : 0}
            duration={2}
            separator=","
          />
        </h5>{" "}
        <div className="mt-0">
          <Card className="border-0 shadow-sm rounded-4">
            {/* TOP SECTION = Payment Type Summary (Green Border Top) */}
            <div
              className="p-3 rounded-top-4"
              style={{
                border: "2px solid #28a745",
                borderBottom: "none",
              }}
            >
              <div className="d-flex justify-content-between align-items-center mb-1">
                <h6 className="mb-0 text-success">Paid Amount</h6>

                <Link to="/dayclose/payment-type-summary">
                  <button className="btn btn-sm btn-soft-secondary rounded-5">
                    <i className="ri-eye-line"></i>
                  </button>
                </Link>
              </div>

              <h4 className="fw-bold text-success mb-0">
                Rs.{" "}
                <CountUp
                  start={0}
                  end={totalSalesAmount || 0}
                  duration={2}
                  separator=","
                />
              </h4>
            </div>

            {/* BOTTOM SECTION = ONGOING ORDERS (Red Border Bottom) */}
            <div
              className="p-3 rounded-bottom-4"
              style={{
                border: "2px solid #dc3545",
                borderTop: "none",
              }}
            >
              <div className="row text-center">
                {/* ONGOING ORDER COUNT */}
                <div className="col-6 border-end">
                  <h6 className="text-muted mb-1">Ongoing Orders</h6>
                  <h4 className="fw-bold text-danger mb-0">
                    {/* <CountUp
                      start={0}
                      end={ongoingOrderCount}
                      duration={2}
                      separator=","
                    /> */}
                    <NumberWithCommas number = {ongoingOrderCount} />
                  </h4>
                </div>

                {/* ONGOING ORDER AMOUNT */}
                <div className="col-6">
                  <h6 className="text-muted mb-1">Ongoing Amount</h6>
                  <h4 className="fw-bold text-danger mb-0">
                    Rs.{" "}
                    {/* <CountUp
                      start={0}
                      end={ongoingOrderAmount}
                      duration={2}
                      separator=","
                    /> */}
                    <NumberWithCommas number = {ongoingOrderAmount} />
                  </h4>
                </div>
              </div>
            </div>
          </Card>
        </div>
        {/* <div>
            <div className="d-flex justify-content-between">
              <h6>Payment Type Summary</h6>
              <Link to="/dayclose/payment-type-summary">
                <button className="btn btn-sm btn-soft-secondary rounded-5">
                  <i className="ri-eye-line"></i>
                </button>
              </Link>
            </div>
            <h4
              className={`fs-4 fw-bold ${
                isDayOpen ? "text-success" : "text-danger"
              }`}
            >
              <CountUp
                start={0}
                end={
                  Array.isArray(paymentSummaryData)
                    ? paymentSummaryData.length
                    : 0
                }
                duration={2}
                separator=","
              />
            </h4>
          </div> */}
        {errorResponse && (
          <>
            <h6 className="text-danger">{errorResponse}</h6>
          </>
        )}
      </CardBody>

      {/* Reactstrap Confirmation Modal */}
      <Modal
        isOpen={showCloseModal}
        toggle={handleCancelClose}
        backdrop="static"
        keyboard={false}
      >
        <ModalHeader toggle={handleCancelClose} className="border-bottom-0">
          <span className="text-warning">
            <i className="ri-alert-line me-2"></i>
            Confirm Day Close
          </span>
        </ModalHeader>
        <ModalBody>
          <div className="text-center">
            <div className="mb-3">
              <i
                className="ri-error-warning-line text-warning"
                style={{ fontSize: "3rem" }}
              ></i>
            </div>
            <h6 className="mb-3">
              You have {Array.isArray(orderData) ? orderData.length : 0}{" "}
              order(s) for today.
            </h6>
            <p className="text-muted mb-0">
              Are you sure you want to close the day? This action will finalize
              all transactions for today.
            </p>
          </div>
        </ModalBody>
        <ModalFooter className="border-top-0 justify-content-center">
          <Button
            color="secondary"
            onClick={handleCancelClose}
            className="me-2"
          >
            Cancel
          </Button>
          <Button color="danger" onClick={handleConfirmClose}>
            <i className="ri-check-line me-1"></i>
            Yes, Close Day
          </Button>
        </ModalFooter>
      </Modal>

      <CloseSummaryPrint
        isOpen={responseModal}
        toggle={toggleResponse}
        data={responseData}
      />
    </Card>
  );
};

export default DayCloseDashboard;
